var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPlanogram = function SvgPlanogram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.927 1.5a2.576 2.576 0 0 1 2.568 2.41l.005.163v13.854a2.576 2.576 0 0 1-2.41 2.568l-.163.005H4.073a2.576 2.576 0 0 1-2.568-2.41l-.005-.163V4.073a2.576 2.576 0 0 1 2.41-2.568l.163-.005h13.854zm1.386 13.063h-7.72v4.749h6.334c.72 0 1.311-.55 1.379-1.252l.007-.133v-3.364zm-8.907 0H2.687v3.364c.001.72.55 1.311 1.253 1.379l.133.006h6.333v-4.75zm0-5.938H2.687v4.75h7.72v-4.75zm8.907 0h-7.72v4.75h7.72v-4.75zm-1.386-5.938H4.073c-.72.001-1.311.55-1.379 1.253l-.006.133v3.364h16.625V4.073a1.388 1.388 0 0 0-1.253-1.379l-.133-.007z",
    fill: "#000",
    fillRule: "nonzero"
  }))));
};

export default SvgPlanogram;